class ItemSearchServiceClass {
  findItemInFP(productCode, items, itemPreference = ['UPC']) {
    const USER_SETTINGS = {
      UPC: 'upc',
      'Item SKU': 'sku',
      'Fulfillment SKU': 'fulfillmentSku',
    };
    return itemPreference.reduce((acc, curr) => {
      const converted = USER_SETTINGS[curr] || USER_SETTINGS.UPC;
      if (!acc) {
        const { unverifiedItem, verifiedItem } = this.findUnverifiedAndVerifiedItems(items, converted, productCode);
        return unverifiedItem || verifiedItem;
      }
      return acc;
    }, undefined);
  }

  findUnverifiedAndVerifiedItems(items, converted, productCode) {
    const matchingItemsMap = items.reduce((itemsObj, currItem) => {
      if (currItem[converted] !== productCode.trim()) {
        return itemsObj;
      }
      if (currItem.verified) {
        return {
          ...itemsObj,
          verifiedItem: currItem,
        };
      }
      return {
        ...itemsObj,
        unverifiedItem: currItem,
      };
    }, {});
    return matchingItemsMap;
  }
}

export const ItemSearchService = new ItemSearchServiceClass();
